





























import { Vue, Component } from 'vue-property-decorator';
import List from '../components/VoteList.vue';

@Component({
  components: {
    List,
  },
})
export default class Home extends Vue {
  enterDetailPage(id: any) {
    this.$router.push({
      path: 'detail',
      query: { id },
    });
  }
}
